import { Pipe, PipeTransform } from "@angular/core";
import { environment } from "../../../environments/environment";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
  name: "shippingRailway"
})
export class ShippingRailway implements PipeTransform {

  constructor(private translate: TranslateService) {
  }

  transform(name: string, prop: string): string {
    if (!prop.includes("Supplier")) {
      return name;
    }

    let fieldName = prop;
    const lastDotIndex = prop.lastIndexOf(".");
    if (lastDotIndex !== -1) {
      fieldName = prop.substring(lastDotIndex + 1);
    }

    if (environment.railway && environment.shipping) {
      return this.handlePropInBothEnvironments(fieldName);
    } else if (environment.railway) {
      return this.handlePropInRailwayEnvironment(fieldName);
    } else if (environment.shipping) {
      return this.handlePropInShippingEnvironment(fieldName);
    }

    return name;
  }

  private handlePropInBothEnvironments(prop: string): string {
    switch (prop) {
      case "prevSupplierCompanyNo":
        return this.translate.instant("COLUMN_SELECTION.COLUMN_NAMES.prevSupplierCompanyNo");
      case "prevSupplierCompanyName":
        return this.translate.instant("COLUMN_SELECTION.COLUMN_NAMES.prevSupplierCompanyName");
      case "prevSupplierLineNo":
        return this.translate.instant("COLUMN_SELECTION.COLUMN_NAMES.prevSupplierLineNo");
      case "prevSupplierLineName":
        return this.translate.instant("COLUMN_SELECTION.COLUMN_NAMES.prevSupplierLineName");
      case "prevSupplierLineDescription":
        return this.translate.instant("COLUMN_SELECTION.COLUMN_NAMES.prevSupplierLineDescription");
      case "nextSupplierCompanyNo":
        return this.translate.instant("COLUMN_SELECTION.COLUMN_NAMES.nextSupplierCompanyNo");
      case "nextSupplierCompanyName":
        return this.translate.instant("COLUMN_SELECTION.COLUMN_NAMES.nextSupplierCompanyName");
      case "nextSupplierLineNo":
        return this.translate.instant("COLUMN_SELECTION.COLUMN_NAMES.nextSupplierLineNo");
      case "nextSupplierLineName":
        return this.translate.instant("COLUMN_SELECTION.COLUMN_NAMES.nextSupplierLineName");
      case "nextSupplierLineDescription":
        return this.translate.instant("COLUMN_SELECTION.COLUMN_NAMES.nextSupplierLineDescription");
    }
  }

  private handlePropInRailwayEnvironment(prop: string): string {
    switch (prop) {
      case "prevSupplierCompanyNo":
        return this.translate.instant("SHARED.PREV_RAILWAY_COMPANY_NO");
      case "prevSupplierCompanyName":
        return this.translate.instant("SHARED.PREV_RAILWAY_COMPANY_NAME");
      case "prevSupplierLineNo":
        return this.translate.instant("SHARED.PREV_RAILWAY_LINE_NO");
      case "prevSupplierLineName":
        return this.translate.instant("SHARED.PREV_RAILWAY_LINE_NAME");
      case "prevSupplierLineDescription":
        return this.translate.instant("SHARED.PREV_RAILWAY_LINE_DESCRIPTION");
      case "nextSupplierCompanyNo":
        return this.translate.instant("SHARED.NEXT_RAILWAY_COMPANY_NO");
      case "nextSupplierCompanyName":
        return this.translate.instant("SHARED.NEXT_RAILWAY_COMPANY_NAME");
      case "nextSupplierLineNo":
        return this.translate.instant("SHARED.NEXT_RAILWAY_LINE_NO");
      case "nextSupplierLineName":
        return this.translate.instant("SHARED.NEXT_RAILWAY_LINE_NAME");
      case "nextSupplierLineDescription":
        return this.translate.instant("SHARED.NEXT_RAILWAY_LINE_DESCRIPTION");
    }
  }

  private handlePropInShippingEnvironment(prop: string): string {
    switch (prop) {
      case "prevSupplierCompanyNo":
        return this.translate.instant("SHARED.PREV_SHIPPING_COMPANY_NO");
      case "prevSupplierCompanyName":
        return this.translate.instant("SHARED.PREV_SHIPPING_COMPANY_NAME");
      case "prevSupplierLineNo":
        return this.translate.instant("SHARED.PREV_SHIPPING_LINE_NO");
      case "prevSupplierLineName":
        return this.translate.instant("SHARED.PREV_SHIPPING_LINE_NAME");
      case "prevSupplierLineDescription":
        return this.translate.instant("SHARED.PREV_SHIPPING_LINE_DESCRIPTION");
      case "nextSupplierCompanyNo":
        return this.translate.instant("SHARED.NEXT_SHIPPING_COMPANY_NO");
      case "nextSupplierCompanyName":
        return this.translate.instant("SHARED.NEXT_SHIPPING_COMPANY_NAME");
      case "nextSupplierLineNo":
        return this.translate.instant("SHARED.NEXT_SHIPPING_LINE_NO");
      case "nextSupplierLineName":
        return this.translate.instant("SHARED.NEXT_SHIPPING_LINE_NAME");
      case "nextSupplierLineDescription":
        return this.translate.instant("SHARED.NEXT_SHIPPING_LINE_DESCRIPTION");
    }
  }
}
